// extracted by mini-css-extract-plugin
export default {"deviceButton":"ToggleDotMenuButton_deviceButton__NYiA0","icon":"ToggleDotMenuButton_icon__VECAa"};